module.exports = __webpack_public_path__ + "img/bm.e4de7d5c.jpg";